/**
 * @generated SignedSource<<45dfc22c374b6f0cea6d6db8cb3f2f42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type auth_getDefaultPath$data = {
  readonly activeContracts: {
    readonly nodes: ReadonlyArray<{
      readonly allowExpensesAccess: boolean | null | undefined;
      readonly enableTimesheets: boolean | null | undefined;
      readonly firm: {
        readonly slug: string | null | undefined;
      } | null | undefined;
      readonly paymentsEnabled: boolean | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly applications: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly confirmedEmail: boolean | null | undefined;
  readonly interviews: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly offers: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly passwordSetupRequired: boolean | null | undefined;
  readonly screening: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"user_isClient" | "user_isGuest" | "user_isMember">;
  readonly " $fragmentType": "auth_getDefaultPath";
};
export type auth_getDefaultPath$key = {
  readonly " $data"?: auth_getDefaultPath$data;
  readonly " $fragmentSpreads": FragmentRefs<"auth_getDefaultPath">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "auth_getDefaultPath"
};

(node as any).hash = "dad23e6e901219bea730e86c0717663b";

export default node;
